module.exports = __webpack_public_path__ + "img/horizontal_4_2_r_pp2_3016.b67cfa51.png";